import { render, staticRenderFns } from "./LicenceCount.vue?vue&type=template&id=81d990f6&scoped=true&"
import script from "./LicenceCount.vue?vue&type=script&lang=js&"
export * from "./LicenceCount.vue?vue&type=script&lang=js&"
import style0 from "./LicenceCount.vue?vue&type=style&index=0&id=81d990f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d990f6",
  null
  
)

export default component.exports